import { BrowseAndSelectTokenTray, Button } from '@/components';
import { TokenInterface } from '@/interfaces';
import { TRADE } from '@/utils/strings';
import { FC, useCallback, useState } from 'react';
import { MdSearch } from 'react-icons/md';
interface Props {
  fullWidth?: boolean;
  onClick?: () => void;
  setPreventBrowseAndSelectTokenTrayFromClosing?: (value: boolean) => void;
  onTokenSelectInBrowseAndSelectTokenTray?: (token: TokenInterface) => void;
  blockchain?: string;
  blockchains?: string[];
}
const SearchIcon = MdSearch as React.ComponentType<any>;
const BrowseAndSelectTokenButton: FC<Props> = ({
  fullWidth = true,
  onClick,
  setPreventBrowseAndSelectTokenTrayFromClosing: setPreventTrayFromClosing,
  onTokenSelectInBrowseAndSelectTokenTray: onTokenSelect,
  blockchain,
  blockchains,
  ...props
}) => {
  const [isTrayOpen, setIsTrayOpen] = useState<boolean>(false);
  const openTray = () => {
    setIsTrayOpen(true);
  };
  const closeTray = useCallback(
    (selectedToken?: TokenInterface) => {
      setIsTrayOpen(false);
      setPreventTrayFromClosing?.(false);
      if (selectedToken) {
        onTokenSelect?.(selectedToken);
      }
    },
    [setPreventTrayFromClosing, onTokenSelect],
  );
  const handleClick = () => {
    if (onClick) onClick();
    openTray();
  };
  return (
    <>
      <Button
        icon={<SearchIcon className="text-accent" />}
        iconStyles={{ intent: 'accent' }}
        fullWidth={fullWidth}
        onClick={handleClick}
        {...props}
      >
        {TRADE.BROWSE_TRADABLE_TOKENS_LABEL}
      </Button>
      <BrowseAndSelectTokenTray
        isOpen={isTrayOpen}
        onClose={closeTray}
        blockchain={blockchain}
        blockchains={blockchains}
      />
    </>
  );
};
export default BrowseAndSelectTokenButton;
